

import { useCallback, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { listadoTodasCotizacion, listadoVentasGuardadas } from "../../../services";





export const useListadoTodasCotizaciones = () => {
    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');

    const { data, isLoading } = useQuery({
        queryKey: ['todas-cotizaciones', { page, termino }], 
        queryFn: () => listadoTodasCotizacion({ page, termino }),
    });

    const chagePage = useCallback((num) => {
        setPage(num - 1);
    }, [])


    const chageTermino = useCallback((valor) => {
        setPage(0);
        setTermino(valor)
    }, [])


    
    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        data, isLoading,
    }
}




export const useListadoTodasVentasSave = () => {

    const { data, isLoading } = useQuery({
        queryKey: ['todas-ventas-save'], 
        queryFn: () => listadoVentasGuardadas(),
    });

    return { data, isLoading,}
}



